"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const moment_1 = __importDefault(require("moment"));
const theme_1 = require("../../helper/theme");
const utils_1 = require("../../helper/utils");
const useDevice_1 = require("../../hooks/useDevice");
const AppText_1 = require("../AppText");
const colors_1 = require("../../common/colors");
const ConversationTime = (({ conversation, darkTheme }) => {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    /**
     *  today : time
     *  yesterday: yesterday
     *  - 2 days ago: wednesday. If within this week.
     *  - 10 days ago : Date
     *
     */
    const conversationTimeString = (0, react_1.useMemo)(() => {
        if ((0, utils_1.isToday)((0, moment_1.default)(conversation.updatedAt))) {
            return (0, moment_1.default)(conversation.updatedAt).format("LT");
        }
        if ((0, utils_1.isYesterday)((0, moment_1.default)(conversation.updatedAt))) {
            return "Yesterday";
        }
        if ((0, utils_1.isWithinAWeek)((0, moment_1.default)(conversation.updatedAt))) {
            return (0, moment_1.default)(conversation.updatedAt).format("dddd");
        }
        return (0, moment_1.default)(conversation.updatedAt).format("MM/DD/YY");
    }, [conversation]);
    return ((0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: darkTheme ? colors_1.Colors.WHITE_SECONDARY : colors_1.Colors.DARK_TEXT, fontSize: (0, theme_1.normalize)(10), fontWeight: 400, textAlign: 'right', marginRight: isMobileScreen ? 16 : undefined, width: 20, children: conversationTimeString }));
});
exports.default = ConversationTime;
